(function () {
  'use strict';

  function bindPerPageSelect(select) {
    if (!select || select.dataset.bound === 'true') return;
    select.dataset.bound = 'true';

    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      var defaultPerPage = select.dataset.defaultPerPage;

      if (defaultPerPage && select.value === defaultPerPage) {
        url.searchParams.delete('per_page');
      } else {
        url.searchParams.set('per_page', select.value);
      }

      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  }

  function init() {
    document.querySelectorAll('[data-collection-per-page]').forEach(bindPerPageSelect);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('collection:rerendered', init);
})();
